var _a;
export const ORCHESTRATOR_GATEWAY_URL = (_a = process.env.ORCHESTRATOR_GATEWAY_URL) !== null && _a !== void 0 ? _a : '';
export const AUTHORIZATION_POLLING = {
    maxAttempts: 10,
    interval: 1000
};
export const POLLING_RETRIES = 10;
export const POLLING_DELAY_MS = 1000;
